/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=8e892394&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8e892394&lang=scss&scoped=true"

import exportComponent from "../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e892394"]])

export default __exports__